var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('div',{staticClass:"col-xl-10"},[_c('panel',{attrs:{"title":_vm.$t("ui.new") + " " + _vm.$helpers.getUplineName(_vm.$store.getters.accountType-1)}},[_c('searchCopy')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }